import { gql } from "@apollo/client";

const CREATE_BOT = gql`
  mutation CreateBot($input: CreateBotInput!) {
    createBot(input: $input) {
      success
      error
      bot {
        id
        botId
        name
        description
        systemPrompt
        handoffEnabled
        primaryColor
        secondaryColor
        backgroundColor
        borderRadius
        position
        avatarUrl
        launcherImageUrl
        darkMode
        welcomeMessage
        placeholderText
        autoOpen
        autoOpenDelay
        typingAnimation
        botTakeoverName
        agentTakeoverName
        enabled
        links
        createdAt
        updatedAt
      }
    }
  }
`;

export default CREATE_BOT;
